import { Button, Flex, Text } from '@chakra-ui/react';
import Balance from '@ui/components/Balance';
import Info from '@ui/components/Info';
import {
  ModalOrDrawerBody,
  ModalOrDrawerFooter,
} from '@ui/components/ModalOrDrawer';
import { TokenIcon } from '@ui/components/TokenIcon';
import { useVnoUsdValue } from '@ui/hooks/useVnoUsdValue';
import { useTranslations } from '@ui/i18n';
import { formatTokenAmount } from '@ui/utils/format';
import { getGardenName, useAllocationOfPendingRewards } from '@ui/utils/garden';
import { GardenVaultSelection } from '@ui/views/Garden/GardenVaultSelection';
import React from 'react';

import { useHarvestAction } from './useHarvestAction';
import {
  HarvestAllStep,
  useHarvestAllDrawer,
  useHarvestAllRewardsInfo,
} from './useHarvestAllDrawer';

function HarvestGarden() {
  const t = useTranslations();
  const activeGarden = useHarvestAllDrawer().activeGarden ?? ['cro', 'VVS'];
  const { defaultLockVault } = useHarvestAllDrawer();
  const { pendingRewardsMap } = useHarvestAllRewardsInfo();
  const pendingRewards = pendingRewardsMap[activeGarden[0]][activeGarden[1]];
  const { into12MonthVault, intoWallet } = useAllocationOfPendingRewards(
    pendingRewards?.data,
  );
  const { mutateAsync: harvest } = useHarvestAction();
  const into12Usd = useVnoUsdValue(into12MonthVault).data;
  const intoWalletUsd = useVnoUsdValue(intoWallet).data;

  return (
    <>
      <ModalOrDrawerBody>
        <Flex flexDir="column" align="center" gap={6}>
          <Text textStyle="h3">
            {t('{coin} allocation', {
              coin: 'VNO',
            })}
          </Text>
          <Balance
            title={getGardenName(activeGarden[0], activeGarden[1]) + ' rewards'}
            amount={pendingRewards?.data}
            usdAmount={pendingRewards?.usd}
            icon={<TokenIcon token="vno" />}
            showUsdAmount
          />
          <Flex w="full" flexDir="column" gap={2}>
            <Info
              title={t('Receive in wallet')}
              value={formatTokenAmount(intoWallet)}
              convertedValue={
                intoWalletUsd
                  ? formatTokenAmount(intoWalletUsd, 2) + ' USD'
                  : undefined
              }
            />
            <Info
              title={t('Lock for 12 months')}
              value={formatTokenAmount(into12MonthVault)}
              convertedValue={
                into12Usd ? formatTokenAmount(into12Usd, 2) + ' USD' : undefined
              }
            />
          </Flex>
          <Flex flexDir="column" w="full">
            <Text mt="36px">{t('Where do you want to lock your VNO?')}</Text>
            <GardenVaultSelection
              mt="6px"
              vaultType={defaultLockVault}
              onChange={(defaultLockVault) =>
                useHarvestAllDrawer.setState({ defaultLockVault })
              }
            />
          </Flex>
        </Flex>
      </ModalOrDrawerBody>
      <ModalOrDrawerFooter>
        <Button
          onClick={() => {
            harvest({ element: activeGarden });
            useHarvestAllDrawer.setState({
              step: HarvestAllStep.LIST,
              activeGarden: undefined,
            });
          }}
        >
          {t('Confirm Allocation')}
        </Button>
      </ModalOrDrawerFooter>
    </>
  );
}

export default HarvestGarden;
